import { render } from "./Welcome.vue?vue&type=template&id=7ed0a84f&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=7ed0a84f&scoped=true&lang=css"

import exportComponent from "/home/alexeyza/git/chargd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed0a84f"]])

export default __exports__